class PasswordField extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['password-input', 'password-toggle']
  }

  static get requiredAttributes () {
    return [
      'data-translation-hide',
      'data-translation-hide-password',
      'data-translation-show',
      'data-translation-show-password',
    ]
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els['password-toggle'].element,
      'click',
      this.handleClick.bind(this),
    )
  }

  handleClick (event) {
    if (!event.target.closest(this.els['password-toggle'].selector)) return

    const passwordInputEl = this.els['password-input'].element
    const showPasswordEl = this.els['password-toggle'].element

    const isPasswordType = passwordInputEl.getAttribute('type') === 'password'

    passwordInputEl.setAttribute('type', isPasswordType ? 'text' : 'password')
    showPasswordEl.textContent = isPasswordType
      ? this.dataset.translationHide
      : this.dataset.translationShow
    showPasswordEl.setAttribute(
      'aria-label',
      String(
        isPasswordType
          ? this.dataset.translationHidePassword
          : this.dataset.translationShowPassword,
      ),
    )
  }
}

if (!customElements.get('password-field')) {
  customElements.define('password-field', PasswordField)
}
